export const UNKNOWN_SHIPPER = '__UNKNOWN_SHIPPER__';

const toShipperKey = (order) => order?.shipper_id || UNKNOWN_SHIPPER;

// Distinct shippers across the orders on the selected routes
export const getRouteShipperOptions = (selectedRoutesList = []) => {
    const byValue = new Map();

    for (const route of selectedRoutesList) {
        const mappingByOrderId = new Map(
            (route?.orders || []).map((m) => [`${m.order_id}_${m.duplicate_override ?? 'DISCARD'}`, m])
        );
        const getMapping = (order_id) =>
            mappingByOrderId.get(`${order_id}_DISCARD`) || mappingByOrderId.get(`${order_id}_DUPLICATE`);

        for (const m of route?.orders || []) {
            const order = m?.order;
            if (!order) continue;

            const mapping = getMapping(m.order_id);
            if (!mapping || mapping.duplicate_override === 'DUPLICATE') continue;

            const value = toShipperKey(order);
            if (byValue.has(value)) continue;

            const label =
                value === UNKNOWN_SHIPPER ? 'Unknown' : order.order_shipper?.business_name || order.shipper_id;
            byValue.set(value, { value, label });
        }
    }

    return [...byValue.values()].sort((a, b) => {
        // Unknown bucket always sorts last.
        if (a.value === UNKNOWN_SHIPPER) return 1;
        if (b.value === UNKNOWN_SHIPPER) return -1;
        return String(a.label).localeCompare(String(b.label));
    });
};

// True when the order belongs to one of the selected shippers
export const orderMatchesShippers = (order, shipperIds) =>
    Array.isArray(shipperIds) && shipperIds.includes(toShipperKey(order));
